import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { StatusIndications } from '../common';

export interface ListItemEditableUniDriver extends BaseUniDriver {
  getValue(): Promise<string>;
  getPlaceholder(): Promise<string>;
  isApproveButtonDisabled(): Promise<boolean>;
  enterText(text: string): Promise<void>;
  clickApprove(): Promise<void>;
  clickCancel(): Promise<void>;
  pressEnter(): Promise<void>;
  isFocus(): Promise<boolean>;
  hasSuffix(): Promise<boolean>;
  getCancelButtonTooltipText(): Promise<string>;
  getApproveButtonTooltipText(): Promise<string>;

  // Status
  hasStatus: (status: StatusIndications) => Promise<boolean>;
  getStatusMessage: () => Promise<string | null>;
}
